// extracted by mini-css-extract-plugin
module.exports = {"text-center":"newslettersignup_text-center__1OHgO","container":"newslettersignup_container___2B89","input":"newslettersignup_input__rkEr5"};